<template>
    <div>
        <b-card
            class="mb-0 trafficking-type"
            style="border: none;">
            <h5>Type of Trafficking & Exploitation</h5>
            <p style="margin-bottom:-5px; font-style: italic;">
                Are you updating victim status for sex trafficking & exploitation,
                labor trafficking & exploitation or other type of exploitation?
                Select an option below.
            </p>
            <br />
            <b-row>
                <b-col>
                    <b-form-select
                        size="lg"
                        :options="traffickingTypes"
                        id="b_type_of_trafficking"
                        v-model="victimInfo.b_type_of_trafficking"
                    ></b-form-select>
                </b-col>
            </b-row>
        </b-card>
        <b-card
            v-if="shouldShowMDTStatus"
            class="mb-0 mdt-status" style="border: none;"
        >
            <h5>Has the Investigative MDT Made a Determination?</h5>
            <p style="margin-bottom:-5px; font-style: italic;">
                Please select an option, even if the investigative MDT team has not made a decision, or the decision is pending.
            </p>
            <br />
            <b-row>
                <b-col>
                    <b-form-select
                        size="lg"
                        :options="mdtStatusOptions"
                        id="b_mdt_status"
                        v-model="victimInfo.b_mdt_status"
                    ></b-form-select>
                </b-col>
            </b-row>
            <b-form-group
                class="mb-2 mt-4"
                v-if="victimInfo.b_mdt_status === 'Yes'"
                label-size='lg'
                label-class='addpersonlabel'
                label='Investigative MDT Determination Date'
                label-for='b_mdt_confirmed_date'
                :horizontal='false'>
                <p class="mb-2" style="font-style: italic;">
                    Please select the date the Investigative MDT made their determination on the case.
                </p>
                <datepicker
                    input-class="form-control-lg datepicker-input"
                    initial-view="year"
                    v-model='victimInfo.b_mdt_confirmed_date'
                    id="b_mdt_confirmed_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"></datepicker>
            </b-form-group>
            <h5 class="mt-2" v-if="victimInfo.b_mdt_status === 'Pending'">
                Case is eligible for Investigate MDT, but victim status determination is pending.
            </h5>
            <b-form-group
                class="mb-2 mt-4"
                v-if="victimInfo.b_mdt_status === 'Pending'"
                label-size='lg'
                label-class='addpersonlabel'
                label='Case Eligibility for Investigative MDT Confirmation Date'
                label-for='b_mdt_decided_date'
                :horizontal='false'>
                <p class="mb-2" style="font-style: italic;">
                    Please select the date the case was decided eligible for Investigative MDT determination.
                </p>
                <datepicker
                    input-class="form-control-lg datepicker-input"
                    initial-view="year"
                    v-model='victimInfo.b_mdt_decided_date'
                    id="b_mdt_decided_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"></datepicker>
            </b-form-group>
            <b-form-group
                class="mb-2 mt-4"
                v-if="victimInfo.b_mdt_status === 'No'"
                label-size='lg'
                label-class='addpersonlabel'
                label='Please select the reason why the Investigative MDT has not made a decision.'
                label-for='b_mdt_rejected_reason'
                :horizontal='false'>
                <b-form-select
                    size="lg"
                    :options="mdtRejectedReasonOptions"
                    id="b_mdt_rejected_reason"
                    v-model="victimInfo.b_mdt_rejected_reason"
                ></b-form-select>
            </b-form-group>
            <b-form-group
                v-if="victimInfo.b_mdt_status === 'No'"
                label-size='lg'
                class="pb-2 pl-1"
                label-class='addpersonlabel'
                label='Comments'
                label-for='b_mdt_rejected_comment'
                :horizontal='false'>
                <b-form-textarea
                    class="mt-3"
                    :maxlength="255"
                    :rows="3"
                    placeholder="Enter Comments"
                    name='b_mdt_rejected_comment'
                    v-model="victimInfo.b_mdt_rejected_comment"></b-form-textarea>
            </b-form-group>
        </b-card>
        <b-card
            v-if="shouldShowVictimStatus"
            class="mb-0 victim-status"
            style="border: none;">
            <b-row>
                <b-col>
                    <b-form-group
                        label-size='lg'
                        class="pb-2 pl-1"
                        label-class='addpersonlabel'
                        label='Victim Status'
                        label-for='b_confirmed'
                        :horizontal='false'>
                        <i
                            class="icon-info"
                            id="tooltip-target-1"
                            style="position:relative;
                            top: -40px;
                            margin-left: 120px;
                            cursor:pointer;"
                            @click=handleVictimStatusModal></i>
                        <p
                            style="margin-top:-40px;
                            padding-bottom: 20px;
                            font-style: italic;
                            color: gray;"
                        >
                            Select an option below. Click the information icon for detailed definitions.
                        </p>
                        <b-form-select
                            size="lg"
                            style="margin-top: -20px"
                            :options="victimStatusOptions"
                            id='b_confirmed'
                            v-model='victimInfo.b_confirmed'></b-form-select>
                    </b-form-group>
                    <b-form-group
                        v-if="victimInfo.b_confirmed === 'Other' && (isOrgManager || isCareCoordinator)"
                        label-size="lg"
                        label="Why?">
                        <b-form-select
                            size="lg"
                            :options="victimStatusOtherOptions"
                            id="b_confirmed_otherText"
                            v-model="victimInfo.b_confirmed_otherText"
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group
                        v-if="isAtRiskOrUnknown"
                        label-size='lg'
                        class="pb-2 pl-1"
                        label-class='addpersonlabel'
                        label='Comments'
                        label-for='b_confirmed_comment'
                        :horizontal='false'>
                        <b-form-textarea
                            class="mt-3"
                            :maxlength="255"
                            :rows="3"
                            placeholder="Enter Comment"
                            name='b_confirmed_comment'
                            v-model="victimInfo.b_confirmed_comment"></b-form-textarea>
                    </b-form-group>
                    <div
                    class="victim-confirmation"
                    v-if="victimInfo.b_confirmed === 'Yes'">
                    <h5>Victim Confirmation</h5>
                    <b-form-group
                        label-size='lg'
                        label-class='addpersonlabel'
                        label='If the person is a confirmed victim of trafficking, how were they confirmed? (Select all that apply)'
                        label-for='b_confirmation_source'
                        :horizontal='false'>
                        <br>
                        <b-form-checkbox
                            switch
                            size='lg'
                            label-size='lg'
                            label-class='addpersonlabel'
                            v-model='victimInfo.b_confirmation_LE'
                            name="check-button-confirm-LE">
                            Confirmed by Law Enforcement
                        </b-form-checkbox>
                        <transition name="form-fade">
                            <div class="sub-group" v-if="victimInfo.b_confirmation_LE">
                                <br>
                                <b-card style="border: none">
                                    <b-row>
                                        <b-col md="4" sm="6">
                                            <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_LE_date' :horizontal='false'>
                                                <datepicker
                                                    input-class="form-control-lg"
                                                    initial-view="year"
                                                    v-model='victimInfo.b_confirmation_LE_date'
                                                    id="b_confirmation_LE_date"
                                                    placeholder="Select Date"
                                                    :format="this.$dateFormatter"
                                                    :disabled-dates="{ from: new Date() }"></datepicker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="8" sm="12">
                                            <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_LE_comment">
                                                <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_LE_comment" v-model="victimInfo.b_confirmation_LE_comment"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </transition>
                        <b-form-checkbox
                            switch
                            size='lg'
                            label-size='lg'
                            label-class='addpersonlabel'
                            v-model='victimInfo.b_confirmation_Victim'
                            name="check-button-confirm-Victim">
                            Confirmed by Victim Outcry
                        </b-form-checkbox>
                        <transition name="form-fade">
                            <div class="sub-group" v-if="victimInfo.b_confirmation_Victim">
                                <br>
                                <b-card style="border: none">
                                    <b-row>
                                        <b-col md="4" sm="6">
                                            <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_Victim_date' :horizontal='false'>
                                                <datepicker
                                                    input-class="form-control-lg"
                                                    initial-view="year"
                                                    v-model='victimInfo.b_confirmation_Victim_date'
                                                    id="b_confirmation_Victim_date"
                                                    placeholder="Select Date"
                                                    :format="this.$dateFormatter"
                                                    :disabled-dates="{ from: new Date() }"
                                                ></datepicker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="8" sm="12">
                                            <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_Victim_comment">
                                                <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_Victim_comment" v-model="victimInfo.b_confirmation_Victim_comment"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </transition>
                        <b-form-checkbox
                            switch
                            size='lg'
                            label-size='lg'
                            label-class='addpersonlabel'
                            v-model='victimInfo.b_confirmation_CPS'
                            name="check-button-confirm-CPS">
                            Confirmed by Child Protective Services
                        </b-form-checkbox>
                        <transition name="form-fade">
                            <div class="sub-group" v-if="victimInfo.b_confirmation_CPS">
                                <br>
                                <b-card style="border: none">
                                    <b-row>
                                        <b-col md="4" sm="6">
                                            <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_CPS_date' :horizontal='false'>
                                            <datepicker
                                                input-class="form-control-lg"
                                                initial-view="year"
                                                v-model='victimInfo.b_confirmation_CPS_date'
                                                id="b_confirmation_CPS_date"
                                                placeholder="Select Date"
                                                :format="this.$dateFormatter"
                                                :disabled-dates="{ from: new Date() }"></datepicker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="8" sm="12">
                                            <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_CPS_comment">
                                                <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_CPS_comment" v-model="victimInfo.b_confirmation_CPS_comment"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </transition>

                        <!-- Temporary Disable of Medical Professional
                        <b-form-checkbox
                        switch
                        size='lg'
                        label-size='lg'
                        label-class='addpersonlabel'
                        v-model='victimInfo.b_confirmation_Med'
                        name="check-button-confirm-Med"
                        value='Yes'
                        unchecked-value='No'
                        @input="updateConfirmed()">
                            Confirmed by Medical Professional
                        </b-form-checkbox>
                        <transition name="form-fade">
                        <div class="sub-group" v-if="victimInfo.b_confirmation_Med">
                            <br>
                            <b-card style="border: none">
                            <b-row>
                                <b-col md="4" sm="6">
                                <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_Med_date' :horizontal='false'>
                                    <datepicker
                                    input-class="form-control-lg"
                                    initial-view="year"
                                    v-model='victimInfo.b_confirmation_Med_date'
                                    id="b_confirmation_Med_date"
                                    placeholder="Select Date"
                                    :format="this.$dateFormatter"
                                    :disabled-dates="{ from: new Date() }"
                                    ></datepicker>
                                </b-form-group>
                                </b-col>
                                <b-col md="8" sm="12">
                                <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_Med_comment">
                                    <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_Med_comment" v-model="victimInfo.b_confirmation_Med_comment"></b-form-textarea>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            </b-card>
                        </div>
                        </transition>
                        -->

                        <b-form-checkbox
                            switch
                            size='lg'
                            label-size='lg'
                            label-class='addpersonlabel'
                            v-model='victimInfo.b_confirmation_Expert'
                            name="check-button-confirm-Expert">
                                Confirmed by Expert Assessment (e.g., Forensic Interview)
                        </b-form-checkbox>
                        <transition name="form-fade">
                            <div class="sub-group" v-if="victimInfo.b_confirmation_Expert">
                                <br>
                                <b-card style="border: none">
                                    <b-row>
                                        <b-col md="4" sm="6">
                                            <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_Expert_date' :horizontal='false'>
                                                <datepicker
                                                    input-class="form-control-lg"
                                                    initial-view="year"
                                                    v-model='victimInfo.b_confirmation_Expert_date'
                                                    id="b_confirmation_Expert_date"
                                                    placeholder="Select Date"
                                                    :format="this.$dateFormatter"
                                                    :disabled-dates="{ from: new Date() }"></datepicker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="8" sm="12">
                                            <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_Expert_comment">
                                                <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_Expert_comment" v-model="victimInfo.b_confirmation_Expert_comment"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </transition>

                        <b-form-checkbox
                            switch
                            size='lg'
                            label-size='lg'
                            label-class='addpersonlabel'
                            v-model='victimInfo.b_confirmation_Other'
                            name="check-button-confirm-Other">
                                Confirmed by other means
                        </b-form-checkbox>
                        <transition name="form-fade">
                            <div class="sub-group" v-if="victimInfo.b_confirmation_Other">
                                <br>
                                <b-card style="border: none">
                                    <b-row>
                                        <b-col md="4" sm="6">
                                            <b-form-group label-class='addpersonlabel' label='Confirmation Date' label-for='b_confirmation_Other_date' :horizontal='false'>
                                                <datepicker
                                                    input-class="form-control-lg"
                                                    initial-view="year"
                                                    v-model='victimInfo.b_confirmation_Other_date'
                                                    id="b_confirmation_Other_date"
                                                    placeholder="Select Date"
                                                    :format="this.$dateFormatter"
                                                    :disabled-dates="{ from: new Date() }"></datepicker>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="8" sm="12">
                                            <b-form-group label="Confirmation Comments" label-class='addpersonlabel' label-for="b_confirmation_Other_comment">
                                                <b-form-textarea rows="5" class="mt-3" placeholder="Enter Comment" name="b_confirmation_Other_comment" v-model="victimInfo.b_confirmation_Other_comment"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                        </transition>
                    </b-form-group>
                </div>
                </b-col>
            </b-row>
        </b-card>
        <div v-if="shouldShowMeansOfTrafficking">
            <b-card
                class="mb-0 means-of-sex-trafficking"
                style="border: none;"
                v-if="isSexTrafficking">
                <h5>Means of Sex Trafficking (select all that apply):</h5>
                <br/>
                <b-row>
                    <b-col>
                    <b-form-group
                        label-size='lg'
                        label-class='addpersonlabel'
                        flush
                        class="pb-2 pl-1"
                        v-for="means in sexTraffickingMeans"
                        :key="means.value">
                        <p-check
                        large
                        class="p-success p-round h5 p-0 m-0 p-smooth p-plain"
                        color="success"
                        v-model="victimInfo[`i_${means.value}`]">
                        {{means.text}}
                        </p-check>
                    </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <b-card
                class="mb-0 means-of-labor-trafficking"
                style="border: none;"
                v-else-if="isLaborTrafficking">
                <h5>Means of Labor Trafficking (select all that apply):</h5>
                <br/>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-size='lg'
                            label-class='addpersonlabel'
                            flush
                            class="pb-2 pl-1"
                            v-for="means in laborTraffickingMeans"
                            :key="means.value">
                            <p-check
                            large
                            class="p-success p-round h5 p-0 m-0 p-smooth p-plain"
                            color="success"
                            v-model="victimInfo[`i_${means.value}`]">
                            {{means.text}}
                            </p-check>
                        </b-form-group>
                        <b-form-group v-if="isIndustryRelatedTrafficking">
                            <b-form-select
                                size="lg"
                                id="nested-industry"
                                v-validate="'required'"
                                data-vv-name="traffickedIndustry"
                                data-vv-as="Industry"
                                placeholder="Please select an option"
                                :options="industryRelatedOptions"
                                v-model="victimInfo.i_l_trafficked_industry"></b-form-select>
                            <span v-show="inputValidationErrors.has('traffickedIndustry')" class="text-info">
                                {{ inputValidationErrors.first('traffickedIndustry') }}
                            </span>
                            <b-form-group
                                label-size="lg"
                                label='Industry Description'
                                v-if="victimInfo.i_l_trafficked_industry === 'Other'">
                                    <b-form-input
                                        size="lg"
                                        v-model="victimInfo.i_l_trafficked_industry_otherText"
                                        data-vv-name="Other"
                                        v-validate="'required'"
                                        data-vv-as="Other"></b-form-input>
                                    <span v-show="inputValidationErrors.has('i_l_trafficked_industry_otherText')" class="text-info">{{ inputValidationErrors.first('i_l_trafficked_industry_otherText') }}</span>
                            </b-form-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <b-card style="border: none;">
                <b-row>
                    <b-col>
                        <!-- Location of Trafficking Incident -->
                        <b-form-group label-size='lg' label-class='addpersonlabel' label='Location of Trafficking Incident' label-for='b_location_of_trafficking' :horizontal='false'>
                            <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the location in which trafficking occurred.</p>
                            <b-form-select size="lg" :options="countyOrParishOptionsTrafficking" id='b_location_of_trafficking' v-model='victimInfo.b_location_of_trafficking'></b-form-select>
                        </b-form-group>
                        <div v-if="victimInfo.b_location_of_trafficking === 'Multiple'">
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Trafficking - Multiple (Primary)' label-for='b_location_of_trafficking_multiple_one' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the primary location in which trafficking occurred.</p>
                                <b-form-select size="lg" :options="countyOrParishOptions" id='b_location_of_trafficking_multiple_one' v-model='victimInfo.b_location_of_trafficking_multiple_one'></b-form-select>
                            </b-form-group>
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Trafficking - Multiple (Secondary)' label-for='b_location_of_trafficking_multiple_two' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Enter the secondary locations in which trafficking occurred.</p>
                                <b-form-input data-vv-name="victimInfo.b_location_of_trafficking_multiple_two"  size="lg" id='b_location_of_trafficking_multiple_two' v-model='victimInfo.b_location_of_trafficking_multiple_two'></b-form-input>
                            </b-form-group>
                        </div>
                        <div v-if="victimInfo.b_location_of_trafficking === 'Out of State'">
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Trafficking - Out of State' label-for='b_location_of_trafficking_out_state' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the state in which trafficking occurred.</p>
                                <b-form-select size="lg" :options="stateAndAbbrev" id='b_location_of_trafficking_out_state' v-model='victimInfo.b_location_of_trafficking_out_state'></b-form-select>
                            </b-form-group>
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Trafficking - Out of State (City)' label-for='b_location_of_trafficking_out_state_city' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Enter the city in which trafficking occurred.</p>
                                <b-form-input data-vv-name="victimInfo.b_location_of_trafficking_out_state_city"  size="lg" id='b_location_of_trafficking_out_state_city' v-model='victimInfo.b_location_of_trafficking_out_state_city'></b-form-input>
                            </b-form-group>
                        </div>
                        <div v-if="victimInfo.b_location_of_trafficking === 'Out of Country'">
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Trafficking - Out of Country' label-for='b_location_of_trafficking_out_country' :horizontal='false'>
                            <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the country in which trafficking occurred.</p>
                            <b-form-select size="lg" :options="getNonUSCountries" id='b_location_of_trafficking_out_country' v-model='victimInfo.b_location_of_trafficking_out_country'></b-form-select>
                            </b-form-group>
                        </div>
                        <!-- Location of Origin -->
                        <b-form-group label-size='lg' label-class='addpersonlabel' label='Location of Origin' label-for='b_location_of_origin' :horizontal='false'>
                            <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the location where the victim identifies as their principal, or home, location.</p>
                            <b-form-select size="lg" :options="countyOrParishOptionsOrigin" id='b_location_of_origin' v-model='victimInfo.b_location_of_origin'></b-form-select>
                        </b-form-group>
                        <div v-if="victimInfo.b_location_of_origin === 'Out of State'">
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Origin - Out of State' label-for='b_location_of_origin_out_state' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Select the state where the victim identifies as their principal, or home, location.</p>
                                <b-form-select size="lg" :options="stateAndAbbrev" id='b_location_of_origin_out_state' v-model='victimInfo.b_location_of_origin_out_state'></b-form-select>
                            </b-form-group>
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Origin - Out of State (City)' label-for='b_location_of_origin_out_state_city' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;" >Enter the city where the victim identifies as their principal, or home, location.</p>
                                <b-form-input data-vv-name="victimInfo.b_location_of_origin_out_state_city"  size="lg" id='b_location_of_origin_out_state_city' v-model='victimInfo.b_location_of_origin_out_state_city'></b-form-input>
                            </b-form-group>
                        </div>
                        <div v-if="victimInfo.b_location_of_origin === 'Out of Country'">
                            <b-form-group label-size='lg' label-class='addpersonlabel' label='Origin - Out of Country' label-for='b_location_of_origin_country' :horizontal='false'>
                                <p style="margin-top:-20px; font-style: italic; color: gray;">Select the country where the victim identifies as their principal, or home, location.</p>
                                <b-form-select size="lg" :options="getNonUSCountries" id='b_location_of_origin_country' v-model='victimInfo.b_location_of_origin_country'></b-form-select>
                            </b-form-group>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <b-modal v-if="showVictimStatusModal" scrollable title='Victim Status' :visible=showVictimStatusModal @ok="handleVictimStatusModal" header-bg-variant="success" header-text-variant="light" size="md" centered id="modal" ok-only>
            <p>{{stateName === 'LA' ? 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.' : 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'}}</p>
            <p>A trafficking event is considered "suspected" when specific information regarding the individual and the surrounding circumstances creates a reasonable belief that the individual is a victim of human trafficking. The presence of one or more risk factors does not necessarily equate to a "suspected" case of trafficking.</p>
            <p>
                An individual is considered “at-risk” for human trafficking when the individual displays one or more risk factors of human trafficking.
                This includes but is not limited to: system-involvement, past history of abuse, homelessness or frequent runaway behavior,
                substance abuse disorder, among other factors. The presence of one or more risk factors for human trafficking, by itself,
                does not equate to a confirmed or suspected case of human trafficking.
            </p>
            <p>
                An individual’s victim status is considered “unknown” when the agency lacks sufficient information to classify the individual as confirmed,
                suspected, or at-risk for human trafficking at this time. Upon gaining additional information on the individual,
                the individual’s victim status should be updated.
            </p>
            <p><strong>Note</strong>: Most screening tools are not diagnostic tools. If a screening for human trafficking has been conducted on an individual, the results of the screening may not be sufficient alone to determine victim status.</p>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import { victimInfo as VictimInfoModel } from '@/api/models'

export default {
    name: 'PersonVictimInfoForm',

    props: {
        victimInfo: {
            type: Object,
            default () {
                return {}
            }
        },

        stateName: {
            type: String,
            default: ''
        },

        compiledVictimInfo: {
            type: Array,
            default () {
                return []
            }
        },

        isCareCoordinator: {
            type: Boolean,
            default: false
        },

        isOrgManager: {
            type: Boolean,
            default: false
        },

        getNonUSCountries: {
            type: Array,
             default () {
                return []
            }
        }

    },

    data () {
        return {
            originalVictimInfo: cloneDeep(this.victimInfo),
            showVictimStatusModal: false,
            mdtStatusOptions: [
                {
                    text: 'Please select an option',
                    value: ''
                },
                {
                    text: 'Yes',
                    value: 'Yes'
                },
                {
                    text: 'Pending',
                    value: 'Pending'
                },
                {
                    text: 'No',
                    value: 'No'
                }
            ],
            victimStatusOtherOptions: [
                {
                    text: 'Please select an option',
                    value: ''
                },
                {
                    text: 'Not determinable',
                    value: 'Not determinable'
                },
                {
                    text: 'Unsubstantiated report',
                    value: 'Unsubstantiated report'
                },
                {
                    text: 'Different Victimization Type',
                    value: 'Different Victimization Type'
                },
                {
                    text: 'Other',
                    value: 'Other'
                }
            ],
            mdtRejectedReasonOptions: [
                {
                    text: 'Please select an option',
                    value: ''
                },
                {
                    text: 'Case not eligible for services',
                    value: 'Case not eligible for services'
                },
                {
                    text: 'Unknown/not determinable',
                    value: 'Unknown/not determinable'
                },
                {
                    text: 'Other',
                    value: 'Other'
                }
            ]
        }
    },

    computed: {
        ...mapGetters({
            traffickingTypesTX: 'getTraffickingTypesTX',
            traffickingTypesLA: 'getTraffickingTypesLA',
            sexTraffickingMeans: 'getSexTraffickingMeans',
            laborTraffickingMeans: 'getLaborTraffickingMeans',
            industryRelatedOptions: 'getIndustryRelatedOptions',
            victimStatusOptionsDefault: 'getVictimStatusOptions',
            victimStatusOptionsForCC: 'getVictimStatusOptionsForCC',
            counties: 'getCountyData',
            parishes: 'getLAParishData',
            stateAndAbbrev: 'getStateAndAbbrev'
        }),

        traffickingType () {
            return this.victimInfo.b_type_of_trafficking
        },

        victimStatusOptions () {
            if (this.isOrgManager && this.originalVictimInfo.b_confirmed === 'Other') {
                return this.victimStatusOptionsForCC
            }

            return this.isCareCoordinator
                ? this.victimStatusOptionsForCC
                : this.victimStatusOptionsDefault
        },

        shouldShowMeansOfTrafficking () {
            return this.shouldShowVictimStatus &&
                this.victimInfo.b_confirmed &&
                !this.isAtRiskOrUnknown
        },

        shouldShowMDTStatus () {
            if (!this.victimInfo.b_type_of_trafficking) {
                return false
            }

            if (this.originalVictimInfo.b_mdt_status) {
                return this.isOrgManager || this.isCareCoordinator
            }

            return this.isCareCoordinator
        },

        shouldShowVictimStatus () {
            if (!this.victimInfo.b_type_of_trafficking) {
                return false
            }

            return this.isCareCoordinator
                ? this.victimInfo.b_mdt_status === 'Yes'
                : true
        },

        isAtRiskOrUnknown () {
            return this.victimInfo.b_confirmed === 'At-Risk' ||
                this.victimInfo.b_confirmed === 'Unknown' ||
                this.victimInfo.b_confirmed === 'Other'
        },

        isSexTrafficking () {
            return this.victimInfo.b_type_of_trafficking === 'sex'
        },

        isLaborTrafficking () {
            return this.victimInfo.b_type_of_trafficking === 'labor'
        },

        isIndustryRelatedTrafficking () {
            return this.isLaborTrafficking &&
                this.victimInfo.i_l_industry_related
        },

        countyOrParishOptions () {
            switch (this.stateName) {
                case 'TX':
                    return this.counties
                case 'LA':
                    return this.parishes
                default:
                    return []
            }
        },
        countyOrParishOptionsTrafficking () {
            switch (this.stateName) {
                case 'TX':
                    return this.counties.concat([{ 'text': 'Multiple', 'value': 'Multiple' }, { 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }, { 'text': 'Unknown', 'value': 'Unknown' }])
                case 'LA':
                    return this.parishes.concat([{ 'text': 'Multiple', 'value': 'Multiple' }, { 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }, { 'text': 'Unknown', 'value': 'Unknown' }])
                default:
                    return []
            }
        },
        countyOrParishOptionsOrigin () {
            switch (this.stateName) {
                case 'TX':
                    return this.counties.concat([{ 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }])
                case 'LA':
                    return this.parishes.concat([{ 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }])
                default:
                    return []
            }
        },
        traffickingTypes () {
            const placeholder = [
                {
                    value: '',
                    text: 'Please select an option'
                }
            ]

            let types = []
            switch (this.stateName) {
                case 'LA':
                    types = this.traffickingTypesLA
                    break
                case 'TX':
                default:
                    types = this.traffickingTypesTX
                    break
            }

            const filteredTypes = types.filter((type) => {
                const isCurrentType = this.victimInfo.b_type_of_trafficking === type.value
                const isNotSelectedYet = this.compiledVictimInfo.findIndex((info) => info.b_type_of_trafficking === type.value) <= -1
                return isCurrentType || isNotSelectedYet
            })
            return placeholder.concat(filteredTypes)
        },
        mdtStatus () {
            return this.victimInfo.b_mdt_status
        },
        victimStatus () {
            return this.victimInfo.b_confirmed
        },
        locationOfTrafficking () {
            return this.victimInfo.b_location_of_trafficking
        },
        locationOfOrigin () {
            return this.victimInfo.b_location_of_origin
        },
        laborTraffickingIndustry () {
            return this.victimInfo.i_l_trafficked_industry
        }
    },

    watch: {
        traffickingType (newValue, oldValue) {
            if (!newValue) {
                this.victimInfo['b_confirmed'] = ''
            } else {
                this.clearTraffickingTypeFields(oldValue)
            }
        },

        mdtStatus (newValue) {
            this.clearMDTRelatedFields()
            if (newValue === 'Yes') {
                return
            }

            this.victimInfo['b_confirmed'] = ''
        },

        victimStatus (newValue, oldValue) {
            if (newValue !== 'Yes') {
                this.clearConfirmationSourceFields()
            }

            if (!this.isAtRiskOrUnknown) {
                if (oldValue === 'Other') {
                    this.victimInfo.b_confirmed_otherText = ''
                }

                this.victimInfo.b_confirmed_comment = ''
                return
            }

            this.clearTraffickingTypeFields('labor')
            this.clearTraffickingTypeFields('sex')

            // Clear location fields
            this.victimInfo.b_location_of_trafficking = ''
            this.victimInfo.b_location_of_origin = ''
        },

        locationOfTrafficking (newValue) {
            switch (newValue) {
                case 'Multiple': {
                    this.victimInfo.b_location_of_trafficking_out_state = ''
                    this.victimInfo.b_location_of_trafficking_out_state_city = ''
                    this.victimInfo.b_location_of_trafficking_out_country = ''
                    break
                }
                case 'Out of State': {
                    this.victimInfo.b_location_of_trafficking_multiple_one = ''
                    this.victimInfo.b_location_of_trafficking_multiple_two = ''
                    this.victimInfo.b_location_of_trafficking_out_country = ''
                    break
                }
                case 'Out of Country': {
                    this.victimInfo.b_location_of_trafficking_multiple_one = ''
                    this.victimInfo.b_location_of_trafficking_multiple_two = ''
                    this.victimInfo.b_location_of_trafficking_out_state = ''
                    this.victimInfo.b_location_of_trafficking_out_state_city = ''
                    break
                }
                default: {
                    this.victimInfo.b_location_of_trafficking_multiple_one = ''
                    this.victimInfo.b_location_of_trafficking_multiple_two = ''
                    this.victimInfo.b_location_of_trafficking_out_state = ''
                    this.victimInfo.b_location_of_trafficking_out_state_city = ''
                    this.victimInfo.b_location_of_trafficking_out_country = ''
                    break
                }
            }
        },

        b_location_of_origin (newValue) {
            switch (newValue) {
                case 'Out of State':
                    this.victimInfo.b_location_of_origin_country = ''
                    break
                case 'Out of Country':
                    this.victimInfo.b_location_of_origin_out_state = ''
                    this.victimInfo.b_location_of_origin_out_state_city = ''
                    break
                default:
                    this.victimInfo.b_location_of_origin_out_state = ''
                    this.victimInfo.b_location_of_origin_out_state_city = ''
                    this.victimInfo.b_location_of_origin_country = ''
                    break
            }
        },

        laborTraffickingIndustry (newValue) {
            if (newValue !== 'Other') {
                this.victimInfo.i_l_trafficked_industry_otherText = ''
            }
        }
    },

    methods: {
        handleVictimStatusModal () {
            this.showVictimStatusModal = !this.showVictimStatusModal
        },

        clearMDTRelatedFields () {
            const mdtRelatedFields = [
                'b_mdt_decided_date',
                'b_mdt_confirmed_date',
                'b_mdt_rejected_reason',
                'b_mdt_rejected_comment'
            ]
            mdtRelatedFields.map((field) => {
                if (
                    field === 'b_mdt_decided_date' &&
                    this.originalVictimInfo[field]
                ) {
                    return
                }

                this.victimInfo[field] = ''
            })
        },

        clearConfirmationSourceFields () {
            const sourceFields = [
                'b_confirmation_source',
                'b_confirmation_LE',
                'b_confirmation_LE_date',
                'b_confirmation_LE_comment',
                'b_confirmation_Victim',
                'b_confirmation_Victim_date',
                'b_confirmation_Victim_comment',
                'b_confirmation_CPS',
                'b_confirmation_CPS_date',
                'b_confirmation_CPS_comment',
                'b_confirmation_Med',
                'b_confirmation_Med_date',
                'b_confirmation_Med_comment',
                'b_confirmation_Expert',
                'b_confirmation_Expert_date',
                'b_confirmation_Expert_comment',
                'b_confirmation_Other',
                'b_confirmation_Other_date',
                'b_confirmation_Other_comment'
            ]

            sourceFields.forEach((field) => {
                this.victimInfo[field] = VictimInfoModel[field]
            })
        },

        clearTraffickingTypeFields (traffickingType) {
            if (traffickingType !== 'labor' && traffickingType !== 'sex') {
                return
            }

            const prefix = traffickingType === 'sex' ? 'i_s' : 'i_l'
            const fields = Object.keys(VictimInfoModel).filter((fieldName) => fieldName.startsWith(prefix))

            fields.map((field) => {
                this.victimInfo[field] = VictimInfoModel[field]
            })
        }
    }
}
</script>

<style lang="scss">
.round-checkbox-group .custom-control-label {
    &::before,
    &::after {
        appearance: none;
        -webkit-appearance: none;
        width: calc(1em + 2px);
        height: calc(1em + 2px);
        background-color: transparent;
        border: 1px solid #bdc3c7;
        border-radius: 50%;
        vertical-align: middle;
        outline: none;
        cursor: pointer;

        &:checked {
            background: #5cb85c;
            transition: all .3s ease;
            border-color: transparent;
        }
    }

    &::before {
        border-color: transparent;
    }
}

.round-checkbox-group .custom-checkbox .custom-control-input:checked {
    & ~ .custom-control-label::after {
        background-image: none;
    }

    & ~ .custom-control-label::before {
        border-color: transparent;
        color: transparent;
        border-radius: 50%;
        background-color: #5cb85c;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/t1/PersonVictimInfoForm.vue